import antdEnUS from 'antd/es/locale/en_US';
import antdEsES from 'antd/es/locale/es_ES';
import en from './locales/en_US.json'
import es from './locales/es_ES.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { THEME_CONFIG } from 'configs/AppConfig';

// Only English and Spanish are offered (see assets/data/language.data.json).
export const resources = {
    en: {
        translation: en,
        antd: antdEnUS
    },
    es: {
        translation: es,
        antd: antdEsES
    },
}

i18n.use(initReactI18next).init({
    resources,
    fallbackLng: 'en',
    lng: THEME_CONFIG.locale,
    interpolation: {
        escapeValue: false
    }
})

export default i18n;
